import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const IdleActions = createActionGroup({
  source: 'Idle',
  events: {

    'Idle Start': emptyProps(),
    'Time Out Warning': emptyProps(),
    'Timed Out': emptyProps(),
    'Idle End': emptyProps(),

  }
});
